import { defineComponent, h } from 'vue';
import utils from '../../../../Shared/utils.jsx';
import methods from '../../../../Shared/methods';

import VerticalStack from '../VerticalStack.jsx';

export default defineComponent({
    name: 'display-basic-modal-dsgn',
    components: {
        VerticalStack,
    },
    data: function () {
        return {
        }
    },
    computed: {
        Root: function () {
            return this.root;
        },
        Vars: function () {
            if (!this.controlData.Vars)
                this.controlData.Vars = {};

            return this.controlData.Vars;
        },
        DesignModel: function () {
            return this.designmodel;
        },
        selected$: function () {
            return this.Root.SelectedNode && this.Root.SelectedModel == this.designmodel;
        },
    },
    methods: {
        ...methods,
        handleClick(e) {
            this.Root.SelectNode(this);
            e.cancelBubble = true;
            e.stopPropagation();
        },
    },
    props: {
        name: '',
        root: null,
        designmodel: null,
        parentType: '',
        controlData: {}
    },
    render() {
        const style = {
            overflow: "auto",
            width: "735px",
            borderRadius: "8px",
            borderStyle: "solid",
            borderColor: "gray",
            padding: "10px",
            margin: "10px",
            display: "flex",
            flexDirection: "column",
        };

        const container = (
            <VerticalStack root={this.root} type="Vertical" parentType="VerticalStack" designmodel={this.designmodel} controlData={this.controlData.Body}>
            </VerticalStack>
        );

        const footer = (
            <VerticalStack root={this.root} type="Horiontal" parentType="HorizontalStack" designmodel={this.designmodel} controlData={this.controlData.Footer}>
            </VerticalStack>
        );

        return (
            <div
                class={{ 'designer-container': true, selected: this.selected$ }}
                style={style}
                onClick={(e) => this.handleClick(e)}>
                <div class={{ "designer-container-hovering": true, 'designer-container-selected': this.selected$ }}></div>
                <span style={{
                    backgroundColor: "gray",
                    color: "white",
                    textAlign: "left",
                    paddingLeft: '10px',
                    paddingRight: '10px',
                    display: 'flex',
                    height: '30px',
                    alignItems: 'center',
                    fontSize: 'larger',
                }}>
                    {this.controlData.Title}
                    <div style="flex-grow: 1;" />
                    <i class="mdi mdi-close-box" />
                </span>
                {container}
                <hr />
                {footer}
            </div>
        );
    }
});